import React from 'react';
import CaptureStripeHeader from './CaptureStripeHeader';

interface PenaltyModalProps {
  open: boolean;
  players: any[];
  side: 'US' | 'THEM' | null;
  cardColor?: 'yellow' | 'red' | null;
  onSelectPenaltyPlayer: (number: number) => void;
  onClose: () => void;
  selectedPlayers?: number[];
  onTeamStat?: () => void;
  submitting?: boolean;
}

const PenaltyModal: React.FC<PenaltyModalProps> = ({
  open,
  players,
  side,
  cardColor = null,
  onSelectPenaltyPlayer,
  onClose,
  selectedPlayers = [],
  onTeamStat,
  submitting = false,
}) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center bg-black bg-opacity-50">
      <div className="relative bg-white shadow-lg p-0 flex flex-col items-center w-full h-[100vh]">
        <CaptureStripeHeader
          tone={cardColor === 'yellow' ? 'yellow' : 'red'}
          title={cardColor === 'yellow' ? 'YELLOW CARD' : 'RED CARD'}
        />
        <div className="w-full flex flex-col items-center px-4 pt-4 pb-6 overflow-y-auto">
          <p className="text-xl font-bold text-center text-sd-dark mb-3 w-full">
            {cardColor === 'yellow' ? 'Who got the yellow card?' : 'Who got the red card?'}
          </p>
          <div className="grid grid-cols-5 gap-5 mb-6 w-full">
            {players.map((player: any, idx: number) => (
              <div
                className={`flex flex-col justify-start items-center ${submitting ? 'opacity-60' : ''}`}
                key={idx}
                onClick={() => {
                  if (submitting) return;
                  onSelectPenaltyPlayer(player.no);
                }}
              >
                <button
                  key={player.no}
                  disabled={submitting}
                  className={`flex flex-col items-center justify-center w-12 h-12 sm:w-14 sm:h-14 rounded-full font-semibold text-white text-base shadow transition-all duration-150
                    ${
                      selectedPlayers.includes(player.no)
                        ? 'bg-[#fff59d] text-black border-2 border-yellow-400'
                        : 'bg-sd-dark'
                    } ${submitting ? 'cursor-not-allowed opacity-70' : ''}
                  `}
                >
                  <span className="text-[26px]">{player.no}</span>
                </button>
                <p className="text-base font-semibold leading-tight text-center">
                  {player.firstName + ' ' + player.lastName}
                </p>
              </div>
            ))}

            {side === 'US' && onTeamStat && (
              <div
                className={`flex flex-col justify-start items-center ${submitting ? 'opacity-60' : ''}`}
                onClick={() => {
                  if (submitting) return;
                  if (onTeamStat) {
                    onTeamStat();
                  }
                }}
              >
                <button
                  disabled={submitting}
                  className={`flex flex-col items-center justify-center w-12 h-12 sm:w-14 sm:h-14 rounded-full font-semibold text-white text-base shadow transition-all duration-150 bg-[#ff6b35] ${
                    submitting ? 'cursor-not-allowed opacity-70' : ''
                  }`}
                >
                  <span className="text-[26px]">T</span>
                </button>
                <p className="text-base font-semibold leading-tight text-center">Team Penalty</p>
              </div>
            )}
          </div>

          <div className="flex gap-4 mt-4">
            <button
              className="px-4 py-2 text-black bg-gray-300 rounded font-semibold disabled:bg-gray-200 disabled:text-gray-500"
              onClick={onClose}
              disabled={submitting}
            >
              {submitting ? 'Saving...' : 'Cancel'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PenaltyModal;
